import functions from "./functions.js";
const recaptcaPublicKey = '6LdtqLwUAAAAAO-PrV_Cd-Ih9FrupyYbk8No6sus';
$(function () {

    const $form = $('.form-contact');
    const form = $form[0];

    const lang = functions.getLang();
    let output = '';

    if (!form) {
        return;
    }
    $form.on('submit', e => {
        e.preventDefault();

        $('.contact-btn').addClass('d-none');
        $('.contact-spinner').removeClass('d-none');
        $('.contact-spinner').addClass('d-flex');

        let params = {};
        $.each($form.serializeArray(), function (i, field) {
            params[field.name] = field.value;
        });

        params['language'] = functions.getLang();

        //$output.html('').addClass('d-none');
        grecaptcha.ready(function () {
            grecaptcha.execute(recaptcaPublicKey, { action: 'contact' }).then(function (token) {
                params['gRecaptchaToken'] = token;
                params = functions.getDataForUrl(params);
                $.post('/services/contact/', params).then(response => {
                    
                    $('#contact-modal').modal('show');
                    $(".response-output").html(response.data).removeClass('d-none');

                    $('.contact-btn').removeClass('d-none');
                    $('.contact-spinner').removeClass('d-flex');
                    $('.contact-spinner').addClass('d-none');

                    setTimeout(() => { 
                        $(".response-output").html('').addClass('d-none');
                     }, 7000);

                    if (response.status == true) {
                        form.reset();
                    }
                });
            });
        });

    });

});